module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.is_loading) ? _c('article', {
    staticClass: "p-v-transition-ud intro"
  }, [_c('img', {
    staticClass: "intro__bg-hex",
    attrs: {
      "src": "img/intro_bg.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "intro__bg-visual u-target-pc _p-iv _p-iv_t",
    attrs: {
      "src": "img/intro_visual_pc.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "l-section-l intro__content"
  }, [_c('img', {
    staticClass: "u-target-sp u-sz-w100-sp _p-iv _p-iv_t",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "src": "img/intro_visual_1_sp.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro__text-1 _p-iv _p-iv_t _p-iv_dl-2"
  }, [_c('p', [_c('strong', {
    staticClass: "intro__strong"
  }, [_vm._v("The prequel takes place"), _c('br', {
    staticClass: "u-target-pc"
  }), _vm._v("two years before “Yuki Yuna is a Hero.”")])]), _vm._v(" "), _c('p', {
    staticClass: "intro__text-1__text"
  }, [_vm._v("\n                Sixth grader Sumi Washio is a hero chosen by the Divine Tree spirit to protect the world. She fulfills her mission while treasuring each day with her classmates Sonoko Nogi and Gin Minowa.\n            ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('img', {
    staticClass: "u-target-sp u-sz-w100-sp _p-iv _p-iv_t _p-iv_dl-4",
    attrs: {
      "src": "img/intro_visual_2_sp.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro__text-2 _p-iv _p-iv_t _p-iv_dl-6"
  }, [_c('p', [_c('strong', {
    staticClass: "intro__strong"
  }, [_vm._v("The story progresses from"), _c('br', {
    staticClass: "u-target-pc"
  }), _vm._v("Sumi Washio to Yuki Yuna")])]), _vm._v(" "), _c('p', {
    staticClass: "intro__text-2__text"
  }, [_vm._v("\n                when an incident disrupts the peaceful existence of the Sanshu Middle School Hero Club…\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "intro__text-3"
  }, [_c('p', [_vm._v("\n                The TV anime “Yuki Yuna is a Hero – Sumi Washio’s Chapter / The Hero’s Chapter” is a two-part story which bookends the first TV anime “Yuki Yuna is a Hero.” “Sumi Washio’s Chapter” is the prequel and “The Hero’s Chapter” tells the tale of what happens afterwards.\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f5522b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/story/introduction.vue
// module id = 53
// module chunks = 0